
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13137',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13137",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.493",
  "data-fetching-client": "static-1.9911",
  "foundations-components": "static-1.8402",
  "foundations-components-legacy": "static-1.1427",
  "foundations-theming": "static-1.4718",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8280",
  "hub-http-shared-msw-handlers": "static-1.10540",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11737",
  "I18n": "static-7.1664",
  "jasmine-runner": "static-1.6703",
  "marketplace-discovery-studio-lib": "static-1.564",
  "marketplace-storefront-base": "static-1.13200",
  "quartz": "static-1.7384",
  "react-dlb": "static-1.85",
  "react-rhumb": "static-1.16966",
  "reactive-variable-buffer-atom": "static-1.3109",
  "reporting-testing-lib": "static-1.10561",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12775",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7570",
  "ui-addon-i18n": "static-1.11397",
  "ui-addon-react-router-dom": "static-1.9791",
  "unified-auth": "static-1.821",
  "unified-auth-core-lib": "static-1.1103",
  "usage-tracker": "static-1.7611",
  "usage-tracker-core": "static-1.7461",
  "customer-data-property-utils": "static-1.8352",
  "hub-http": "static-1.6468",
  "integrations-lib": "static-1.16942",
  "marketplace-ui-common": "static-1.20620",
  "marketplace-ui-install": "static-1.606",
  "property-management-iframe": "static-1.14017",
  "quartz-config": "static-1.1162",
  "quartz-core": "static-1.6603",
  "quartz-routing": "static-1.814",
  "quick-fetch": "static-1.4100",
  "react": "static-7.191",
  "rpc-client-utils": "static-1.4917",
  "ts-schema": "static-1.4262",
  "ui-universal-auth": "static-1.9307",
  "UIComponents": "static-3.8683",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3585",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3661",
  "quartz-webpack": "static-1.3608",
  "bend-plugin-quartz-routing": "static-1.462",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4671",
  "floating-ui": "static-1.62",
  "foundations-assets": "static-1.5135",
  "foundations-theming-specialty": "static-1.2434",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9681",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.63",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5522",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.496",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2496",
  "ui-fonts": "static-1.999",
  "ui-images": "static-2.1231",
  "bend-plugin-foundations-theming": "static-1.3201",
  "foundations-theming-base": "static-1.3703",
  "stylex": "static-1.38",
  "HeadJS": "static-2.790",
  "hs-test-utils-bend-plugin": "static-1.3391",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4571",
  "ui-addon-video-player": "static-1.8958",
  "ai-components-ui-library": "static-1.9613",
  "ai-rendering-library": "static-1.11018",
  "chirp-fetch": "static-1.2147",
  "connections-embed-lib": "static-1.1438",
  "copilot-toolkit": "static-1.11762",
  "feedback-loader": "static-1.29744",
  "laboratory-lib": "static-3.7406",
  "marketplace-embed": "static-1.22834",
  "marketplace-ui-details": "static-1.10515",
  "marketplace-ui-reviews": "static-1.20575",
  "marketplace-ui-tracking": "static-1.14790",
  "sanitize-text": "static-1.8405",
  "usage-tracker-multi": "static-1.6025",
  "usage-tracker-session-replay": "static-1.5297",
  "wootric-nps": "static-1.7167",
  "quartz-head": "static-1.1049",
  "web-vitals": "static-1.11",
  "apollo-link-hub-http": "static-2.4911",
  "immer": "static-1.94",
  "immerable": "static-1.4406",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2652",
  "reporting-data": "static-1.68628",
  "cssUtils": "static-1.873",
  "flux-actions": "static-1.361",
  "HubStyle": "static-2.12044",
  "PatternValidationJS": "static-1.3152",
  "react-colorpicker": "static-2.10463",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10619",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7601",
  "icons": "static-2.675",
  "marketplace-ui-apps-core": "static-1.19152",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4765",
  "foundations-components-test-utils": "static-1.5885",
  "quartz-i18n": "static-1.1059",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.368",
  "ads-unified-auth-lib": "static-1.1105",
  "google-sheets-integration-lib": "static-1.945",
  "microsoft-drive-auth-lib": "static-1.38",
  "surveymonkey-integration-lib": "static-1.389",
  "slack-ui-library": "static-1.10652",
  "fsm": "static-1.3994",
  "customer-data-objects": "static-1.7940",
  "property-translator": "static-1.5652",
  "hs-locale-management": "static-1.261",
  "frontend-preferences-client": "static-1.8181",
  "hs-promise-utils": "static-1.5850",
  "hubspot-apollo-client": "static-1.5133",
  "integrations-error-boundary-lib": "static-1.14357",
  "integrations-tracking-lib": "static-1.5863",
  "native-integrations-shared-strings": "static-1.8032",
  "sanitize": "static-1.4730",
  "superstore": "static-1.5010",
  "ui-shepherd-react": "static-3.10518",
  "ai-settings-ui-library": "static-1.8265",
  "hub-http-janus": "static-1.870",
  "hubspotter-http": "static-1.4830",
  "immutable-less": "static-1.4905",
  "marketplace-ui-client-types": "static-1.18027",
  "nav-meta": "static-1.30366",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18326",
  "ui-product-approvals-common": "static-1.896",
  "ai-studio-lib": "static-1.12376",
  "hubspot-prosemirror": "static-1.18886",
  "integrations-reconnect-lib": "static-1.411",
  "ui-addon-iframeable": "static-1.9330",
  "ui-addon-integrations-directory-panel": "static-2.8281",
  "ui-product-approvals": "static-1.29001",
  "ui-tool-access": "static-1.10408",
  "inbound-db-properties-service-client": "static-1.4025",
  "property-management-common": "static-1.6305",
  "opentelemetry-fe-types": "static-1.21",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.568",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.396",
  "quartz-auth": "static-1.1059",
  "quartz-test": "static-1.1059",
  "quartz-tracking": "static-1.763",
  "trellis-components": "static-1.2515",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.327",
  "bender-build-tools": "static-1.3382",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22677",
  "ContentUtils": "static-1.69063",
  "customer-data-objects-ui-components": "static-1.13284",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2751",
  "breeze-engine-core": "static-1.869",
  "breeze-onboarding-components": "static-1.634",
  "customer-data-filters-ui": "static-1.40784",
  "customer-data-reference-ui-components": "static-1.13435",
  "embedded-academy-lib": "static-1.15393",
  "ExportDialog": "static-6.10633",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41929",
  "reporting-snowflake": "static-1.57246",
  "reporting-ui-components": "static-2.65899",
  "reporting-visualizations": "static-1.60704",
  "trial-components-library": "static-1.14035",
  "trellis-theming": "static-1.1220",
  "ui-addon-teams": "static-1.21860",
  "upgrade-components-lib": "static-1.463",
  "magpie-lib": "static-1.5723",
  "navigation-components": "static-1.18729",
  "breeze-engine-lib": "static-1.1591",
  "magpie-types": "static-1.5183",
  "simple-logging-lib": "static-1.3305",
  "fail-safe": "static-1.209",
  "app-governance-lib": "static-1.2309",
  "developer-experience-shared-components": "static-1.10755",
  "purchase-motions-components": "static-1.6291",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10070",
  "usage-tracker-anonymous": "static-1.6028",
  "usage-tracker-public": "static-1.7422",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3953",
  "reference-resolvers": "static-1.8434",
  "ui-extensibility-client-types": "static-1.4175",
  "hubspot-apollo-cache": "static-1.592",
  "universal-page-editor-lib": "static-1.3262",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3450",
  "atom": "static-1.5340",
  "merchandise-lib": "static-1.273",
  "salesImages": "static-1.530",
  "codemirror": "static-5.99",
  "react-codemirror": "static-1.10894",
  "ui-addon-draggable": "static-3.5009",
  "content-assistance-lib": "static-1.8141",
  "content-media-capture": "static-1.5332",
  "customer-data-ui-utilities": "static-1.10082",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24377",
  "growth-payments-core": "static-1.26090",
  "knowledge-content-types": "static-1.8623",
  "payment-link-components": "static-1.24087",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20243",
  "ui-addon-emoji-picker": "static-1.10139",
  "ui-business-units-lib": "static-1.9338",
  "video-components-external": "static-1.12077",
  "video-data-lib": "static-1.35735",
  "navigation-messaging": "static-1.8056",
  "collaboration-sidebar": "static-1.58628",
  "react-dnd-compat": "static-1.4870",
  "batch-promise": "static-1.1796",
  "crm-component-utils": "static-1.39747",
  "crm-properties-common-lib": "static-1.6145",
  "customer-data-properties": "static-1.52456",
  "external-options-client-types": "static-1.4307",
  "framework-data-schema-resolvers": "static-1.7147",
  "property-value-citations": "static-1.3070",
  "reference-resolvers-lite": "static-1.8355",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10538",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5069",
  "content-icons-ui": "static-1.2319",
  "breeze-artifacts-sdk": "static-1.208",
  "onboarding-journeys-lib": "static-1.797",
  "pulse": "static-1.880",
  "conversations-skeleton-state": "static-1.7503",
  "crm-message-bus": "static-1.43660",
  "customer-data-filters-ui-msw-helpers": "static-1.23219",
  "events-data-lib": "static-1.495",
  "FormUrlGenerator": "static-2.4981",
  "framework-builder-read-service-client": "static-1.4189",
  "hs-resources": "static-1.445",
  "multi-account-reference-resolvers": "static-1.1251",
  "onboarding-scopes": "static-1.6709",
  "onboarding-tours": "static-1.17050",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14383",
  "academy-common-lib": "static-1.14853",
  "dashboard-lib": "static-1.82651",
  "getting-started-shared-tasks": "static-1.19130",
  "hubspot-prosemirror-plugins": "static-1.18878",
  "share-with-third-party-component-lib": "static-1.8959",
  "ui-asset-management-lib": "static-1.11350",
  "user-context": "static-1.5368",
  "reporting-plugins": "static-1.10677",
  "reporting-reports": "static-1.68306",
  "hubs-service-types": "static-1.1513",
  "purchase-motions-api": "static-1.6294",
  "signup-constants": "static-1.19522",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.976",
  "nest": "static-1.490",
  "breeze-engine-chat-components": "static-1.569",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.160",
  "framework-listing-lib": "static-2.29393",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31349",
  "apps-service-types": "static-1.3996",
  "oauth-service-types": "static-1.4507",
  "signup-ui-url-generator": "static-2.8314",
  "onboarding-tours-client": "static-1.5264",
  "one-click-checkout": "static-1.318",
  "platform-infra-nav-components": "static-1.7856",
  "subscription-experience-data-types": "static-1.15209",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.10005",
  "redux-thunk": "static-2.77",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29230",
  "content-media-composition-data-lib": "static-1.13136",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4680",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.643",
  "ui-addon-opt": "static-4.8618",
  "commerce-tours-lib": "static-1.6547",
  "growth-onboarding-reliability": "static-1.5335",
  "sales-checkout-service-client": "static-1.3783",
  "data-token-picker": "static-1.16825",
  "FileManagerLib": "static-1.40017",
  "content-media-compositions": "static-2.17143",
  "media-bridge-lib": "static-1.19346",
  "chatspot-widget-iframe": "static-1.22668",
  "collaboration-sidebar-common": "static-1.3425",
  "marketing-platform-lib": "static-1.7123",
  "card-properties-lib": "static-1.44921",
  "commerce-subscription-lib": "static-1.37694",
  "crm-actions": "static-1.6605",
  "crm-cards-sdk": "static-1.44406",
  "customer-data-properties-shared-msw-handlers": "static-1.9867",
  "customer-data-tracking": "static-1.7136",
  "calling-global-api": "static-1.65402",
  "calling-internal-common": "static-1.31572",
  "calling-lifecycle-internal": "static-1.66784",
  "calling-lifecycle-messages": "static-1.59078",
  "commerce-products-lib": "static-1.10426",
  "conditional-properties-service-client": "static-1.3982",
  "crm-index-visualization-core": "static-1.4483",
  "crm-links": "static-1.6579",
  "crm-pipelines-api-client-types": "static-1.4316",
  "formula-editor": "static-1.14685",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4392",
  "meetings-icalendar-utils-lib": "static-1.890",
  "multi-currency-client-types": "static-1.3877",
  "object-builder-ui-client": "static-1.49557",
  "pipeline-validation-client-types": "static-1.4150",
  "smart-data-capture-core": "static-1.43",
  "smart-property-lib": "static-1.8187",
  "tiered-pricing": "static-1.1883",
  "topics-actions-lib": "static-1.419",
  "ui-addon-form-validation": "static-1.11240",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.266",
  "framework-data-schema-quick-fetch": "static-1.7052",
  "bend-plugin-pulse": "static-1.383",
  "event-emitter": "static-1.1207",
  "fast-json-patch": "static-1.67",
  "restore-request-side-panel-lib": "static-1.1573",
  "growth-data-modal": "static-1.5829",
  "growth-onboarding-confetti": "static-1.3316",
  "growth-onboarding-next-action-utils": "static-1.2609",
  "onboarding-tours-utils": "static-1.1116",
  "ui-shepherd-tracker": "static-1.7899",
  "academy-service-client": "static-1.3943",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39876",
  "SafeStorage": "static-1.4659",
  "video-embed": "static-1.36569",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24927",
  "viral-links-lib": "static-1.7329",
  "nested-table": "static-1.488",
  "timezone-utils": "static-2.5502",
  "getting-started-shared-tasks-store": "static-1.18248",
  "campaign-roi-lib": "static-1.10020",
  "ui-addon-calendars": "static-2.5583",
  "customer-data-views-management": "static-1.25947",
  "framework-data-table": "static-2.12463",
  "nudge-client-utils": "static-1.3079",
  "nudge-custom-ui-functions": "static-1.1430",
  "switchboard-lib": "static-1.469",
  "access-check-ui-lib": "static-1.1498",
  "app-users-service-client": "static-1.5874",
  "app-users-service-types": "static-1.5282",
  "mini-checkout-client": "static-1.27413",
  "onboarding-utils": "static-1.5617",
  "permissions-shared-i18n-strings-fe": "static-1.2118",
  "ui-coaching-tips-shared-config": "static-1.29215",
  "checkout-sdk": "static-3.24256",
  "payment-method-components": "static-1.7101",
  "touchless-buying-components": "static-1.6124",
  "upgrade-catalog-service-types": "static-1.3740",
  "edison-service-client-types": "static-1.647",
  "growth-onboarding-feedback-components": "static-1.6839",
  "audio-components": "static-1.6282",
  "FileManagerImages": "static-1.37528",
  "video-components": "static-1.14079",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92747",
  "customer-data-sidebar": "static-2.46656",
  "enrichment-lib": "static-1.172",
  "ui-addon-draggable-compat": "static-2.4518",
  "universal-record-utils-lib": "static-1.1761",
  "commerce-billing-lib": "static-1.20010",
  "commerce-shared-components-lib": "static-1.19141",
  "commerce-tools-ui-lib": "static-1.10969",
  "crm-fe-perf": "static-1.23155",
  "calling-error-reporting": "static-1.31579",
  "shared-worker-versioning": "static-1.11295",
  "calling-usage-tracker": "static-1.6793",
  "voice-sms-access-library": "static-1.1926",
  "commerce-permissions": "static-1.1031",
  "products-iframe-lib": "static-1.8511",
  "products-ui-components-shared-msw-handlers": "static-1.10922",
  "crm-index-associations-lib": "static-1.6697",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10623",
  "sales-views-client-types": "static-1.4512",
  "bark-lib": "static-1.16761",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.583",
  "policy-lib": "static-1.7050",
  "react-tinymce": "static-1.55892",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10686",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55018",
  "tinymce-plugins": "static-1.58132",
  "tinymce-themes": "static-1.56988",
  "onboarding-data-sync-lib": "static-1.2426",
  "growth-onboarding-next-action-components": "static-1.2637",
  "user-context-client": "static-1.4763",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4786",
  "outpost": "static-1.4414",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22094",
  "sales-email-signature-service-client": "static-1.4100",
  "ts-utils-lib": "static-1.426",
  "crm-export-dialog": "static-1.6538",
  "crm-view-components": "static-1.1014",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7583",
  "tasks-actions-lib": "static-1.33",
  "nudge-custom-function-registry": "static-1.2836",
  "nudge-renderer-utils": "static-1.3155",
  "whisper-core-api": "static-1.7245",
  "InboxConnectUtils": "static-4.15473",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46761",
  "hub-http-rxjs": "static-1.835",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4246",
  "company-details-components": "static-1.6455",
  "react-performance-metrics-lib": "static-1.810",
  "pricing-pages-ui-components": "static-1.15540",
  "quote-checkout-service-types": "static-1.3714",
  "social-insights-client-types": "static-1.22685",
  "crm_universal": "static-1.22435",
  "customer-data-email": "static-1.18462",
  "card-payment-highlight-lib": "static-1.37887",
  "card-subscription-highlight-lib": "static-1.40117",
  "commerce-contract-lib": "static-1.13187",
  "invoices-highlight-card-lib": "static-1.55572",
  "orders-highlight-card-lib": "static-1.22107",
  "products-highlight-card-lib": "static-1.18709",
  "quotes-highlight-card-lib": "static-1.72753",
  "enrichment-properties-lib": "static-1.17839",
  "crm-object-search-query-utilities": "static-1.10124",
  "utility-belt": "static-1.2786",
  "payments-enrollment-embed-lib": "static-1.23718",
  "stripe-embedded-components": "static-1.7935",
  "customer-data-rte": "static-1.33572",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6204",
  "payments-post-enroll-local-storage-lib": "static-1.5360",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38843",
  "calling-orchestration-schema": "static-1.36703",
  "react-reducer-toolkit": "static-1.16282",
  "hub-http-contrib": "static-1.3293",
  "interframe": "static-3.5010",
  "tinymce-data": "static-1.41103",
  "ui-addon-sales-email": "static-1.5469",
  "layout-dnd-components": "static-1.12900",
  "layout-dnd-utils": "static-1.11875",
  "ui-brand-identity-lib": "static-1.16249",
  "NamespacedHubStyle": "static-2.9230",
  "meetings-connect-utils-lib": "static-1.7864",
  "access-control-lib": "static-1.10691",
  "EmailComponents": "static-1.55468",
  "EmailData": "static-1.54146",
  "redux-less": "static-2.9733",
  "company-details-service-types": "static-1.4194",
  "segments-query-core": "static-1.1679",
  "pricing-pages-api": "static-1.15405",
  "sequences-lib": "static-1.8474",
  "ui-gdpr-components": "static-1.10610",
  "products-ui-components": "static-1.40944",
  "accounting-integrations-ui-components": "static-1.7477",
  "invoices-ui-lib": "static-1.55588",
  "commerce-products-api": "static-1.2643",
  "invoices-iframe-lib": "static-1.57646",
  "quotes-modal-lib": "static-1.103431",
  "quotes-ui-lib": "static-1.81474",
  "crm-source-interpretation-lib": "static-1.5587",
  "data-agent-utils": "static-1.234",
  "stripe-connect-js": "static-1.74",
  "draft-content-plugins": "static-1.28836",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10200",
  "ContentComponents": "static-2.72019",
  "marketing-contacts-lib": "static-1.10921",
  "marketing-email-service-types": "static-1.2067",
  "messaging-editing-lib": "static-1.47047",
  "messaging-usage-based-billing-components-lib": "static-1.1909",
  "automation-ui-source-apps": "static-1.19578",
  "automation-ui-types": "static-1.20496",
  "messaging-types-lib": "static-1.46784",
  "onboarding-settings-client": "static-1.4764",
  "sequences-client-types-lib": "static-1.8331",
  "commerce-tax-lib": "static-1.793",
  "price-books-api": "static-1.1647",
  "price-books-components": "static-1.1705",
  "property-description-translator": "static-1.4095",
  "ramp-editor": "static-1.817",
  "commerce-analytics-service-client": "static-1.3771",
  "totals-ui-components": "static-1.24218",
  "SalesContentIndexUI": "static-3.9575",
  "advanced-menus-core": "static-1.15517",
  "advanced-menus-lib": "static-1.12397",
  "ui-memberships-settings-lib": "static-1.34755",
  "automation-ui-ubb": "static-1.6412",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7592",
  "data-token-views": "static-1.16806",
  "forms-utils-lib": "static-1.13030",
  "payments-embed-points-lib": "static-1.13523",
  "simple-menus-core": "static-1.15516",
  "simple-menus-lib": "static-1.17033",
  "videoconference-integration-components": "static-1.7185",
  "marketing-contacts-client": "static-1.7764",
  "mc-hard-limits-client-types": "static-1.156",
  "automation-applications-service-types": "static-1.3648",
  "automation-platform-service-types": "static-1.2659",
  "ContentEditorUI": "static-2.77817",
  "short-messages-app-service-client": "static-1.4172",
  "web-interactives-components": "static-1.14185",
  "web-interactives-data": "static-1.14186",
  "messaging-shared-utils-lib": "static-1.1358",
  "messaging-user-info-utils-lib": "static-1.1528",
  "email-portal-health-service-types": "static-1.1232",
  "line-items-api": "static-1.1043",
  "commerce-totals-service-types": "static-1.3999",
  "FireAlarmUi": "static-1.4686",
  "sales-templates-service-types-lib": "static-1.4351",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22432",
  "automation-ui-usage-tracking": "static-1.21895",
  "data-studio-ubb": "static-1.3427",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27578",
  "content-management-data-lib": "static-1.5885",
  "copilot-plugins": "static-1.11734",
  "cta-picker": "static-1.37008",
  "customer-agent-discovery-components-lib": "static-1.3794",
  "editor-components": "static-1.13587",
  "editor-iframe-lib": "static-1.8741",
  "error-messaging-js": "static-1.5451",
  "FormsCommonComponents": "static-1.86478",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.69",
  "redux-request-state": "static-1.10904",
  "SharedLegalStrings": "static-1.2002",
  "smart-content-core": "static-1.43092",
  "smart-content-lib": "static-1.43745",
  "social-composer-lib": "static-1.60108",
  "structured-content-lib": "static-1.25838",
  "theme-previewer-lib": "static-1.53866",
  "tinymce-copilot": "static-1.17086",
  "xray-recommendation-lib": "static-1.8213",
  "automation-ui-routing": "static-1.21853",
  "sql-reporting-client-types": "static-1.5853",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42712",
  "campaigns-utils-lib": "static-1.3456",
  "reporting-enablement": "static-1.23737",
  "forms-ai-lib": "static-1.4702",
  "codemirror-dlb": "static-1.59376",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6694",
  "report-customization-components": "static-1.13820",
  "data-quality-ui-library": "static-1.13698",
  "reporting-filters": "static-1.926",
  "reporting-insights-lib": "static-1.2481"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13137",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.493",
  "data-fetching-client": "/data-fetching-client/static-1.9911",
  "foundations-components": "/foundations-components/static-1.8402",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1427",
  "foundations-theming": "/foundations-theming/static-1.4718",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8280",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10540",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11737",
  "I18n": "/I18n/static-7.1664",
  "jasmine-runner": "/jasmine-runner/static-1.6703",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.564",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13200",
  "quartz": "/quartz/static-1.7384",
  "react-dlb": "/react-dlb/static-1.85",
  "react-rhumb": "/react-rhumb/static-1.16966",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3109",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10561",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12775",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7570",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11397",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9791",
  "unified-auth": "/unified-auth/static-1.821",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1103",
  "usage-tracker": "/usage-tracker/static-1.7611",
  "usage-tracker-core": "/usage-tracker-core/static-1.7461",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8352",
  "hub-http": "/hub-http/static-1.6468",
  "integrations-lib": "/integrations-lib/static-1.16942",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20620",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.606",
  "property-management-iframe": "/property-management-iframe/static-1.14017",
  "quartz-config": "/quartz-config/static-1.1162",
  "quartz-core": "/quartz-core/static-1.6603",
  "quartz-routing": "/quartz-routing/static-1.814",
  "quick-fetch": "/quick-fetch/static-1.4100",
  "react": "/react/static-7.191",
  "rpc-client-utils": "/rpc-client-utils/static-1.4917",
  "ts-schema": "/ts-schema/static-1.4262",
  "ui-universal-auth": "/ui-universal-auth/static-1.9307",
  "UIComponents": "/UIComponents/static-3.8683",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3585",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3661",
  "quartz-webpack": "/quartz-webpack/static-1.3608",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.462",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4671",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-assets": "/foundations-assets/static-1.5135",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2434",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9681",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5522",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.496",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2496",
  "ui-fonts": "/ui-fonts/static-1.999",
  "ui-images": "/ui-images/static-2.1231",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3201",
  "foundations-theming-base": "/foundations-theming-base/static-1.3703",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.790",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3391",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4571",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8958",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9613",
  "ai-rendering-library": "/ai-rendering-library/static-1.11018",
  "chirp-fetch": "/chirp-fetch/static-1.2147",
  "connections-embed-lib": "/connections-embed-lib/static-1.1438",
  "copilot-toolkit": "/copilot-toolkit/static-1.11762",
  "feedback-loader": "/feedback-loader/static-1.29744",
  "laboratory-lib": "/laboratory-lib/static-3.7406",
  "marketplace-embed": "/marketplace-embed/static-1.22834",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10515",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20575",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14790",
  "sanitize-text": "/sanitize-text/static-1.8405",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6025",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5297",
  "wootric-nps": "/wootric-nps/static-1.7167",
  "quartz-head": "/quartz-head/static-1.1049",
  "web-vitals": "/web-vitals/static-1.11",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4911",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4406",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "reporting-data": "/reporting-data/static-1.68628",
  "cssUtils": "/cssUtils/static-1.873",
  "flux-actions": "/flux-actions/static-1.361",
  "HubStyle": "/HubStyle/static-2.12044",
  "PatternValidationJS": "/PatternValidationJS/static-1.3152",
  "react-colorpicker": "/react-colorpicker/static-2.10463",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10619",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7601",
  "icons": "/icons/static-2.675",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19152",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4765",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5885",
  "quartz-i18n": "/quartz-i18n/static-1.1059",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.368",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1105",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.945",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.38",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.389",
  "slack-ui-library": "/slack-ui-library/static-1.10652",
  "fsm": "/fsm/static-1.3994",
  "customer-data-objects": "/customer-data-objects/static-1.7940",
  "property-translator": "/property-translator/static-1.5652",
  "hs-locale-management": "/hs-locale-management/static-1.261",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8181",
  "hs-promise-utils": "/hs-promise-utils/static-1.5850",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5133",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14357",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5863",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8032",
  "sanitize": "/sanitize/static-1.4730",
  "superstore": "/superstore/static-1.5010",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10518",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8265",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hubspotter-http": "/hubspotter-http/static-1.4830",
  "immutable-less": "/immutable-less/static-1.4905",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18027",
  "nav-meta": "/nav-meta/static-1.30366",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18326",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.896",
  "ai-studio-lib": "/ai-studio-lib/static-1.12376",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18886",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.411",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9330",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8281",
  "ui-product-approvals": "/ui-product-approvals/static-1.29001",
  "ui-tool-access": "/ui-tool-access/static-1.10408",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4025",
  "property-management-common": "/property-management-common/static-1.6305",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.21",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.568",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.396",
  "quartz-auth": "/quartz-auth/static-1.1059",
  "quartz-test": "/quartz-test/static-1.1059",
  "quartz-tracking": "/quartz-tracking/static-1.763",
  "trellis-components": "/trellis-components/static-1.2515",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.327",
  "bender-build-tools": "/bender-build-tools/static-1.3382",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22677",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13284",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2751",
  "breeze-engine-core": "/breeze-engine-core/static-1.869",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.634",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40784",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13435",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15393",
  "ExportDialog": "/ExportDialog/static-6.10633",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41929",
  "reporting-snowflake": "/reporting-snowflake/static-1.57246",
  "reporting-ui-components": "/reporting-ui-components/static-2.65899",
  "reporting-visualizations": "/reporting-visualizations/static-1.60704",
  "trial-components-library": "/trial-components-library/static-1.14035",
  "trellis-theming": "/trellis-theming/static-1.1220",
  "ui-addon-teams": "/ui-addon-teams/static-1.21860",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.463",
  "magpie-lib": "/magpie-lib/static-1.5723",
  "navigation-components": "/navigation-components/static-1.18729",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1591",
  "magpie-types": "/magpie-types/static-1.5183",
  "simple-logging-lib": "/simple-logging-lib/static-1.3305",
  "fail-safe": "/fail-safe/static-1.209",
  "app-governance-lib": "/app-governance-lib/static-1.2309",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10755",
  "purchase-motions-components": "/purchase-motions-components/static-1.6291",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10070",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6028",
  "usage-tracker-public": "/usage-tracker-public/static-1.7422",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3953",
  "reference-resolvers": "/reference-resolvers/static-1.8434",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4175",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.592",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3262",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3450",
  "atom": "/atom/static-1.5340",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.99",
  "react-codemirror": "/react-codemirror/static-1.10894",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5009",
  "content-assistance-lib": "/content-assistance-lib/static-1.8141",
  "content-media-capture": "/content-media-capture/static-1.5332",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10082",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24377",
  "growth-payments-core": "/growth-payments-core/static-1.26090",
  "knowledge-content-types": "/knowledge-content-types/static-1.8623",
  "payment-link-components": "/payment-link-components/static-1.24087",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20243",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10139",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9338",
  "video-components-external": "/video-components-external/static-1.12077",
  "video-data-lib": "/video-data-lib/static-1.35735",
  "navigation-messaging": "/navigation-messaging/static-1.8056",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58628",
  "react-dnd-compat": "/react-dnd-compat/static-1.4870",
  "batch-promise": "/batch-promise/static-1.1796",
  "crm-component-utils": "/crm-component-utils/static-1.39747",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6145",
  "customer-data-properties": "/customer-data-properties/static-1.52456",
  "external-options-client-types": "/external-options-client-types/static-1.4307",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7147",
  "property-value-citations": "/property-value-citations/static-1.3070",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8355",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10538",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5069",
  "content-icons-ui": "/content-icons-ui/static-1.2319",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.208",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.797",
  "pulse": "/pulse/static-1.880",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7503",
  "crm-message-bus": "/crm-message-bus/static-1.43660",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23219",
  "events-data-lib": "/events-data-lib/static-1.495",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4981",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4189",
  "hs-resources": "/hs-resources/static-1.445",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1251",
  "onboarding-scopes": "/onboarding-scopes/static-1.6709",
  "onboarding-tours": "/onboarding-tours/static-1.17050",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14383",
  "academy-common-lib": "/academy-common-lib/static-1.14853",
  "dashboard-lib": "/dashboard-lib/static-1.82651",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19130",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18878",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8959",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11350",
  "user-context": "/user-context/static-1.5368",
  "reporting-plugins": "/reporting-plugins/static-1.10677",
  "reporting-reports": "/reporting-reports/static-1.68306",
  "hubs-service-types": "/hubs-service-types/static-1.1513",
  "purchase-motions-api": "/purchase-motions-api/static-1.6294",
  "signup-constants": "/signup-constants/static-1.19522",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.976",
  "nest": "/nest/static-1.490",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.569",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.160",
  "framework-listing-lib": "/framework-listing-lib/static-2.29393",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31349",
  "apps-service-types": "/apps-service-types/static-1.3996",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8314",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5264",
  "one-click-checkout": "/one-click-checkout/static-1.318",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7856",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15209",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10005",
  "redux-thunk": "/redux-thunk/static-2.77",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29230",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13136",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4680",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.643",
  "ui-addon-opt": "/ui-addon-opt/static-4.8618",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6547",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5335",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3783",
  "data-token-picker": "/data-token-picker/static-1.16825",
  "FileManagerLib": "/FileManagerLib/static-1.40017",
  "content-media-compositions": "/content-media-compositions/static-2.17143",
  "media-bridge-lib": "/media-bridge-lib/static-1.19346",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22668",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3425",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7123",
  "card-properties-lib": "/card-properties-lib/static-1.44921",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37694",
  "crm-actions": "/crm-actions/static-1.6605",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44406",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9867",
  "customer-data-tracking": "/customer-data-tracking/static-1.7136",
  "calling-global-api": "/calling-global-api/static-1.65402",
  "calling-internal-common": "/calling-internal-common/static-1.31572",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66784",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59078",
  "commerce-products-lib": "/commerce-products-lib/static-1.10426",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3982",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4483",
  "crm-links": "/crm-links/static-1.6579",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4316",
  "formula-editor": "/formula-editor/static-1.14685",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4392",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.890",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3877",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49557",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4150",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.43",
  "smart-property-lib": "/smart-property-lib/static-1.8187",
  "tiered-pricing": "/tiered-pricing/static-1.1883",
  "topics-actions-lib": "/topics-actions-lib/static-1.419",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11240",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.266",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7052",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.383",
  "event-emitter": "/event-emitter/static-1.1207",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1573",
  "growth-data-modal": "/growth-data-modal/static-1.5829",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3316",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2609",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1116",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7899",
  "academy-service-client": "/academy-service-client/static-1.3943",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39876",
  "SafeStorage": "/SafeStorage/static-1.4659",
  "video-embed": "/video-embed/static-1.36569",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24927",
  "viral-links-lib": "/viral-links-lib/static-1.7329",
  "nested-table": "/nested-table/static-1.488",
  "timezone-utils": "/timezone-utils/static-2.5502",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18248",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10020",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5583",
  "customer-data-views-management": "/customer-data-views-management/static-1.25947",
  "framework-data-table": "/framework-data-table/static-2.12463",
  "nudge-client-utils": "/nudge-client-utils/static-1.3079",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1430",
  "switchboard-lib": "/switchboard-lib/static-1.469",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1498",
  "app-users-service-client": "/app-users-service-client/static-1.5874",
  "app-users-service-types": "/app-users-service-types/static-1.5282",
  "mini-checkout-client": "/mini-checkout-client/static-1.27413",
  "onboarding-utils": "/onboarding-utils/static-1.5617",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2118",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29215",
  "checkout-sdk": "/checkout-sdk/static-3.24256",
  "payment-method-components": "/payment-method-components/static-1.7101",
  "touchless-buying-components": "/touchless-buying-components/static-1.6124",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3740",
  "edison-service-client-types": "/edison-service-client-types/static-1.647",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6839",
  "audio-components": "/audio-components/static-1.6282",
  "FileManagerImages": "/FileManagerImages/static-1.37528",
  "video-components": "/video-components/static-1.14079",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92747",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46656",
  "enrichment-lib": "/enrichment-lib/static-1.172",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4518",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1761",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20010",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19141",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10969",
  "crm-fe-perf": "/crm-fe-perf/static-1.23155",
  "calling-error-reporting": "/calling-error-reporting/static-1.31579",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11295",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6793",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1926",
  "commerce-permissions": "/commerce-permissions/static-1.1031",
  "products-iframe-lib": "/products-iframe-lib/static-1.8511",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10922",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6697",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10623",
  "sales-views-client-types": "/sales-views-client-types/static-1.4512",
  "bark-lib": "/bark-lib/static-1.16761",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.583",
  "policy-lib": "/policy-lib/static-1.7050",
  "react-tinymce": "/react-tinymce/static-1.55892",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10686",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55018",
  "tinymce-plugins": "/tinymce-plugins/static-1.58132",
  "tinymce-themes": "/tinymce-themes/static-1.56988",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2426",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2637",
  "user-context-client": "/user-context-client/static-1.4763",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4786",
  "outpost": "/outpost/static-1.4414",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22094",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4100",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "crm-export-dialog": "/crm-export-dialog/static-1.6538",
  "crm-view-components": "/crm-view-components/static-1.1014",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7583",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.33",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2836",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3155",
  "whisper-core-api": "/whisper-core-api/static-1.7245",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15473",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46761",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.835",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4246",
  "company-details-components": "/company-details-components/static-1.6455",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.810",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15540",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3714",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "crm_universal": "/crm_universal/static-1.22435",
  "customer-data-email": "/customer-data-email/static-1.18462",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37887",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40117",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13187",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55572",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22107",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18709",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72753",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17839",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10124",
  "utility-belt": "/utility-belt/static-1.2786",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23718",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7935",
  "customer-data-rte": "/customer-data-rte/static-1.33572",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6204",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5360",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38843",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36703",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16282",
  "hub-http-contrib": "/hub-http-contrib/static-1.3293",
  "interframe": "/interframe/static-3.5010",
  "tinymce-data": "/tinymce-data/static-1.41103",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5469",
  "layout-dnd-components": "/layout-dnd-components/static-1.12900",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11875",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16249",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9230",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7864",
  "access-control-lib": "/access-control-lib/static-1.10691",
  "EmailComponents": "/EmailComponents/static-1.55468",
  "EmailData": "/EmailData/static-1.54146",
  "redux-less": "/redux-less/static-2.9733",
  "company-details-service-types": "/company-details-service-types/static-1.4194",
  "segments-query-core": "/segments-query-core/static-1.1679",
  "pricing-pages-api": "/pricing-pages-api/static-1.15405",
  "sequences-lib": "/sequences-lib/static-1.8474",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10610",
  "products-ui-components": "/products-ui-components/static-1.40944",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7477",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55588",
  "commerce-products-api": "/commerce-products-api/static-1.2643",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57646",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103431",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81474",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5587",
  "data-agent-utils": "/data-agent-utils/static-1.234",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "draft-content-plugins": "/draft-content-plugins/static-1.28836",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10200",
  "ContentComponents": "/ContentComponents/static-2.72019",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10921",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2067",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47047",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1909",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19578",
  "automation-ui-types": "/automation-ui-types/static-1.20496",
  "messaging-types-lib": "/messaging-types-lib/static-1.46784",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4764",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8331",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.793",
  "price-books-api": "/price-books-api/static-1.1647",
  "price-books-components": "/price-books-components/static-1.1705",
  "property-description-translator": "/property-description-translator/static-1.4095",
  "ramp-editor": "/ramp-editor/static-1.817",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3771",
  "totals-ui-components": "/totals-ui-components/static-1.24218",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9575",
  "advanced-menus-core": "/advanced-menus-core/static-1.15517",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12397",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34755",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6412",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7592",
  "data-token-views": "/data-token-views/static-1.16806",
  "forms-utils-lib": "/forms-utils-lib/static-1.13030",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13523",
  "simple-menus-core": "/simple-menus-core/static-1.15516",
  "simple-menus-lib": "/simple-menus-lib/static-1.17033",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7185",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7764",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.156",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3648",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2659",
  "ContentEditorUI": "/ContentEditorUI/static-2.77817",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4172",
  "web-interactives-components": "/web-interactives-components/static-1.14185",
  "web-interactives-data": "/web-interactives-data/static-1.14186",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1358",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1528",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1232",
  "line-items-api": "/line-items-api/static-1.1043",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3999",
  "FireAlarmUi": "/FireAlarmUi/static-1.4686",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4351",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22432",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21895",
  "data-studio-ubb": "/data-studio-ubb/static-1.3427",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27578",
  "content-management-data-lib": "/content-management-data-lib/static-1.5885",
  "copilot-plugins": "/copilot-plugins/static-1.11734",
  "cta-picker": "/cta-picker/static-1.37008",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3794",
  "editor-components": "/editor-components/static-1.13587",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8741",
  "error-messaging-js": "/error-messaging-js/static-1.5451",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86478",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.69",
  "redux-request-state": "/redux-request-state/static-1.10904",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2002",
  "smart-content-core": "/smart-content-core/static-1.43092",
  "smart-content-lib": "/smart-content-lib/static-1.43745",
  "social-composer-lib": "/social-composer-lib/static-1.60108",
  "structured-content-lib": "/structured-content-lib/static-1.25838",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53866",
  "tinymce-copilot": "/tinymce-copilot/static-1.17086",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8213",
  "automation-ui-routing": "/automation-ui-routing/static-1.21853",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5853",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42712",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3456",
  "reporting-enablement": "/reporting-enablement/static-1.23737",
  "forms-ai-lib": "/forms-ai-lib/static-1.4702",
  "codemirror-dlb": "/codemirror-dlb/static-1.59376",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6694",
  "report-customization-components": "/report-customization-components/static-1.13820",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13698",
  "reporting-filters": "/reporting-filters/static-1.926",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2481"
}
};
